var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultOrganization(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f2f2f2;stroke:#cad0d9;}.b{fill:#b7bec8;}.c{stroke:none;}.d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-501 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(501 252)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 200,
    height: 200,
    rx: 100
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 199,
    height: 199,
    rx: 99.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(553 308)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-246.787-180.839H-252.8v-54.124c0-8.419-4.811-12.028-7.818-12.629l-19.244-6.014v-6.615a3.124,3.124,0,0,0-1.2-2.406,3.616,3.616,0,0,0-2.406-.6L-323.763-251.8s-7.216,1.8-7.216,11.426v59.536h-6.014A2.841,2.841,0,0,0-340-177.833a2.841,2.841,0,0,0,3.007,3.007h90.206a2.841,2.841,0,0,0,3.006-3.007,2.84,2.84,0,0,0-3.006-3.007Zm-39.09,0h-39.09v-59.536c0-4.21,2.406-5.412,3.007-5.412l36.082-10.223Zm27.062,0h-21.048v-66.753l17.44,6.014h.6c.6,0,3.007.6,3.007,6.615Zm-49.313-60.739h-6.014v6.014h6.014Zm13.832,0h-6.014v6.014h6.014Zm-13.832,9.622h-6.014v6.014h6.014Zm13.832,0h-6.014v6.014h6.014Zm-13.832,10.224h-6.014v6.014h6.014Zm13.832,0h-6.014v6.014h6.014Zm-13.832,10.223h-6.014v6.014h6.014Zm13.832,0h-6.014v6.014h6.014Zm-13.832,9.622h-6.014v6.014h6.014Zm13.832,0h-6.014v6.014h6.014Zm-13.832,10.224h-6.014v6.014h6.014Zm13.832,0h-6.014v6.014h6.014Zm22.251-34.278h6.014v-6.014h-6.014Zm0,10.223h6.014v-6.014h-6.014Zm0,10.223h6.014v-6.014h-6.014Zm0,9.622h6.014v-6.014h-6.014Zm0,10.223h6.014v-6.014h-6.014Zm0,0",
    transform: "translate(340 263.228)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultOrganization);
export default __webpack_public_path__ + "static/media/DefaultOrganization.620d61986abf1294fef5d2f635233c86.svg";
export { ForwardRef as ReactComponent };